import VueRouter from 'vue-router';
import routes from './routes';

import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics';

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const isPublic = to.matched.some(record => record.meta.isPublic);

  if (!isPublic && !currentUser) {
    next('/welcome');
  }
  else {
    next();
  }
});

export default router;
